import { Component, OnInit } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Util } from 'src/shared/util/util';

import { AddressModel } from 'src/models/address.model';
import { RoomScanService, RoomScanResult } from 'src/providers/room-scan/room-scan';

@Component({
    templateUrl: 'ar-room-scan-result.page.html',
    standalone: false
})
export class ArRoomScanResultPage implements OnInit {

  address: AddressModel;
  loaded: boolean;
  scanResult: RoomScanResult;
  isUploading = false;
  uploadSuccess = false;

  boundGoToProperty = this.goToProperty.bind(this);
  boundScanAgain = this.scanAgain.bind(this);
  boundViewScan = this.viewScan.bind(this);
  boundUploadToCloud = this.uploadToCloud.bind(this);

  constructor(
    private navCtrl: CustomNavController,
    private roomScanService: RoomScanService,
    private util: Util
  ) {}

  ngOnInit() {
    this.loaded = false;
    this.address = this.navCtrl.getParam('address', true);
    this.scanResult = this.navCtrl.getParam('scanResult', true);
    this.loaded = true;
  }

  async viewScan() {
    if (this.scanResult?.usdzPath) {
      // TODO: Fix this
      console.log('[viewScan] scanResult:', this.scanResult);
      console.log('[viewScan] scanResult.usdzPath:', this.scanResult.usdzPath);
      await this.roomScanService.openARQuickLook(this.scanResult.usdzPath);
    } else {
      this.util.showError('No 3D model found to view.');
    }
  }

  async uploadToCloud() {
    if (this.isUploading || this.uploadSuccess) {
      return;
    };

    try {
      this.isUploading = true;
      const updatedResult = await this.roomScanService.uploadScanResults(this.scanResult, this.address.id);

      if (updatedResult.usdzUrl || updatedResult.jsonUrl) {
        this.scanResult = updatedResult;
        this.uploadSuccess = true;
        this.util.showSuccess('Scan uploaded to cloud successfully!');
      } else {
        throw new Error('Upload failed to return cloud URLs');
      }
    } catch (error) {
      this.util.showError(`Failed to upload scan: ${error instanceof Error ? error.message : String(error)}`);
    } finally {
      this.isUploading = false;
    }
  }

  goToProperty() {
    this.navCtrl.navigateForward(`properties?propertyId=${this.address.id}`);
  }

  scanAgain() {
    const params = {
      address: this.address
    };
    this.navCtrl.navigateForward('ar-room-scan', params);
  }
}
